import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useOrganizationContext } from "../../contexts/organizations/organizationsContext";
import { useCreateApplication } from "../../hooks/reactQueryHooks/useApplications";
import { useGenerateKey } from "../../hooks/reactQueryHooks/useKeys";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { AnalyticsGA } from "../../utils/AnalyticsGA";
import { userManager } from "../auth/components/AzureLoginHelper";
import { CongratulationComponent } from "./CongratulationComponent";
import type { IKeyData } from "./index";

const OnboardingTouchcastPage = () => {
  const [keyData, setKeyData] = useState<IKeyData | null>(null);
  const [loading, setLoading] = useState(false);
  const { setValue: setStorageValue, storedValue: firstTimeUser } =
    useLocalStorage("firstTimeUser", {});
  const navigate = useNavigate();

  const { mutateAsync: generateKeyMutation } = useGenerateKey();
  const { mutateAsync: createAppMutation } = useCreateApplication();
  const { currentOrganization } = useOrganizationContext();

  const getStarted = useCallback(async () => {
    setLoading(true);
    const firstKeyName = "CogCache API Key";
    const orgId = currentOrganization?.id;
    let user = await userManager.getUser();

    setStorageValue({
      ...firstTimeUser,
      [user?.profile.sub || ""]: false,
    });

    if (!orgId) return;
    const application = await createAppMutation({
      name: "CogCache Project",
      id: orgId,
    });

    const key = await generateKeyMutation({
      organizationId: orgId,
      name: firstKeyName,
      applicationId: application.id,
    });

    if (key) {
      setKeyData({
        name: key.name,
        key: key?.key || "",
      });
    }
    setLoading(false);
  }, [
    currentOrganization,
    generateKeyMutation,
    createAppMutation,
    firstTimeUser,
    setStorageValue,
  ]);

  const openMainPage = () => {
    navigate("/safety-compliance/cache");
  };

  useEffect(() => {
    AnalyticsGA.enableGA();
  }, []);

  useEffect(() => {
    if (currentOrganization) {
      getStarted().catch(console.error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrganization]);

  return (
    <CongratulationComponent
      keyName={keyData?.name}
      keyData={keyData?.key}
      getStarted={openMainPage}
      loadingStatus={loading}
      userExist
      isTouchcast
    />
  );
};

export { OnboardingTouchcastPage };
